import { render, staticRenderFns } from "./LicenseManager.vue?vue&type=template&id=0cf04bf5"
import script from "./LicenseManager.vue?vue&type=script&lang=js"
export * from "./LicenseManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports